module.exports = __webpack_public_path__ + "img/icon-partner-with-us-breadcrumb-arrow.e6eeefd.svg";